import { UserImport } from '@tmx/data-access';

import { AssetsImportResponse } from '../../models/assets-import-response';
import {
  AssetsInvalidRecord,
  AssetsInvalidRecordReason,
} from '../../models/assets-invalid-record';

function convertToReason(errorCode: number) {
  return (
    errorCode === -1600
      ? 'invalid-email'
      : errorCode === -1601
        ? 'invalid-phone'
        : 'duplicate'
  ) as AssetsInvalidRecordReason;
}

export function catalogAssetsImportResponse(
  errorDetails: { errorCode: number; externalIds: string[] }[],
  assetLookup: Map<string, UserImport>,
  subsetSize: number,
  importResponse: AssetsImportResponse
) {
  if (errorDetails.length === 0) {
    importResponse.imported += subsetSize;
    return;
  }

  for (const { errorCode, externalIds } of errorDetails) {
    const reason = convertToReason(errorCode);
    for (const externalId of externalIds) {
      const asset = assetLookup.get(externalId);
      importResponse.invalid.push(
        new AssetsInvalidRecord(externalId, reason, {
          externalId,
          email: asset?.email ?? '',
          firstName: asset?.firstName ?? '',
          lastName: asset?.lastName ?? '',
          phoneNumber: asset?.phoneNumber ?? '',
        })
      );
    }
  }

  importResponse.imported += subsetSize - importResponse.invalid.length;
}
